var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenNewsLogoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1392,
    height: 2977,
    viewBox: "0 0 1392 2977",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.634 1942.67H364.074C364.074 1942.67 300.525 3011.33 733.543 2908.03L730.435 2975.43C730.418 2975.41 39.3572 3041.11 144.634 1942.67Z",
    fill: "#DBE58A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.28 1605.92L1141.03 1172.48L890.765 1605.92H1037.01C1056.6 2780.97 630.252 2969.35 630.252 2969.35C781.994 2993 1259.16 3031.8 1266.67 1605.92H1391.28Z",
    fill: "#1A9954"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.63 1033.49H1027.2C1027.2 1033.49 1090.77 -35.1655 657.734 68.1292L660.842 0.74997C660.842 0.74997 1351.9 -64.9494 1246.63 1033.49Z",
    fill: "#DBE58A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1370.23L250.249 1803.65L500.515 1370.23H354.266C334.679 195.165 761.027 6.76826 761.027 6.76826C609.302 -16.8842 132.138 -55.6723 124.612 1370.23H0Z",
    fill: "#1A9954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenNewsLogoVector);
export default __webpack_public_path__ + "static/media/Golden News Logo Vector.d12e171be74f64357dd8a926032efaf7.svg";
export { ForwardRef as ReactComponent };